import React, { useState, useEffect } from 'react';
import SummaryDisplay from '../../MicroProbe//Companies/SummaryDisplayNews';
import { newsSummaryPrice } from '../../../../services/newsSummary';

const PerformanceOverview = ({ inputData }) => {
    const [keyword, setKeyword] = useState('');
    const [summaryData, setSummaryData] = useState(null);
    const [isLoadingSummary, setIsLoadingSummary] = useState(false); 

    useEffect(() => {
        setKeyword(`${inputData.name} price`);
    }, [inputData]);

    const fetchSummary = async () => {
        setIsLoadingSummary(true); 
        setSummaryData(null); 
        try {
            const summary = await newsSummaryPrice(keyword, inputData.name); 
            setSummaryData(summary); 
        } catch (error) {
            console.error('Failed to fetch summary:', error);
        }
        setIsLoadingSummary(false); 
    }

    const handleSearchClick = () => {
        fetchSummary();
    }

    const isLoading = isLoadingSummary;

    return (
        <div>
            <h3>Market Price</h3>
       
            <div>
                <button onClick={handleSearchClick}>Highlights</button>
                {isLoading && <div>Thinking, please wait …</div>}
                {summaryData && <SummaryDisplay summary={summaryData.response} />}
            </div>
        </div>
    );
}

export default PerformanceOverview;